"use strict";
'use es6'; // ⚠️ Hello HubSpotters, Please don't import from this module. ☠️

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isNaN", {
  enumerable: true,
  get: function get() {
    return _lodash.isNaN;
  }
});
Object.defineProperty(exports, "max", {
  enumerable: true,
  get: function get() {
    return _lodash.max;
  }
});
Object.defineProperty(exports, "min", {
  enumerable: true,
  get: function get() {
    return _lodash.min;
  }
});
exports.uniqueId = exports.last = exports.first = void 0;

var _lodash = require("../../vendor/lodash.custom");

// allow `uniqueIdLocal` export to be spied. imports are immutable in babel 7
var uniqueIdLocal = _lodash.uniqueId;
/** Returns the first element of an Array or NodeList */

exports.uniqueId = uniqueIdLocal;

var first = function first(list) {
  return list == null || list.length === 0 ? undefined : list[0];
};
/** Returns the last element of an Array or NodeList */


exports.first = first;

var last = function last(list) {
  return list == null || list.length === 0 ? undefined : list[list.length - 1];
};

exports.last = last;